(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelector('.footer__cookie-consent')?.addEventListener('click', (event) => {
    event.preventDefault();
    window.privacyBanner?.showBanner();
  });

  const footer = document.querySelector('footer.footer');

  if (footer && 'IntersectionObserver' in window) {
    const footerObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0)) return;

      observer.disconnect();

      if (window.rybbit) {
        window.rybbit.event('Footer Viewed');
      }
    });

    footerObserver.observe(footer);
  }

  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const accreditationContainer = document.getElementById('accreditations');

    if (!accreditationContainer) return;

    fetch('https://static.38-3d.co.uk/accreditations.json', {
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        return response.json();
      })
      .then((data) => {
        const items = Array.isArray(data?.accreditations) ? data.accreditations : [];

        if (!items.length) {
          return;
        }

        const list = document.createElement('div');
        list.className = 'footer__accreditations';

        items.forEach((item) => {
          const itemWrapper = document.createElement('div');
          itemWrapper.className = 'footer__accreditation';

          const logoLink = item.link ? document.createElement('a') : document.createElement('span');
          const logo = document.createElement('img');

          if (item.link) {
            logoLink.href = item.link;
            logoLink.target = '_blank';
            logoLink.title = item.alt;
            logoLink.rel = 'noopener noreferrer';
            logoLink.setAttribute('data-rybbit-event', 'Accreditation Click');
            logoLink.setAttribute('data-rybbit-prop-accreditation', item.name);
            logoLink.setAttribute('aria-label', item.name || 'Accreditation');
          } else {
            logo.title = item.alt;
            logo.setAttribute('data-rybbit-event', 'Accreditation Click');
            logo.setAttribute('data-rybbit-prop-accreditation', item.name);
          }

          logo.src = item.logo;
          logo.alt = item.alt || 'Accreditation logo';
          logo.loading = 'lazy';
          logo.decoding = 'async';
          logoLink.appendChild(logo);

          itemWrapper.appendChild(logoLink);
          list.appendChild(itemWrapper);
        });

        accreditationContainer.innerHTML = '';
        accreditationContainer.appendChild(list);
      })
      .catch((error) => {
        console.warn('Accreditations could not be loaded:', error);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
